import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function InfoDialog(props) {
	const open = props.open ? true : false;
	const title = props.title ? props.title : "";
	const message = props.message ? props.message : "";
	const captionOK = props.captionOK ? props.captionOK : "OK";
	const handleOK = props.handleOK ? props.handleOK : () => {};

	return (
		<div>
			<Dialog
				open={open}
				onClose={(event, reason) => {
					if (reason !== 'backdropClick') {
							onClose(event, reason)
					}
				}}
				disableEscapeKeyDown
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				maxWidth="md"
        fullWidth
			>
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleOK}
						variant="outlined"
						color="primary"
						autoFocus
					>
						{captionOK}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
